import React from 'react';
import { connect } from 'react-redux';

import { isPluginActive } from 'helpers/whiteLabel';
import { getStripeConfig } from 'helpers/payment';
import { PAYMENT_PLUGIN_STRIPE_CONNECT } from 'js/constants';

import List from 'components/List';
import Count from 'components/Count';
import Data from 'components/Data';

import DashboardInitSoleRepresentative from 'components/layout/hint/DashboardInitSoleRepresentative';
import DashboardInitPlugins from 'components/layout/hint/DashboardInitPlugins';
import DashboardInitLocations from 'components/layout/hint/DashboardInitLocations';
import DashboardInitUsers from 'components/layout/hint/DashboardInitUsers';
import DashboardInitCars from 'components/layout/hint/DashboardInitCars';
import DashboardFinishPluginConfig from 'components/layout/hint/DashboardFinishPluginConfig';
import DashboardStripeOnboarding from 'components/layout/hint/DashboardStripeOnboarding';
import DashboardInitSepaAgreement from 'components/layout/hint/DashboardInitSepaAgreement';
// import DashboardInitJahreswagen from 'components/layout/hint/DashboardInitJahreswagen';

import may from 'js/security';

const dashList = [
  {
    id: 'SoleRepresentative',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles) && !may('ROLE_SOLE_REPRESENTATIVE', user.roles);
    },
    dataElements: () => {
      return null;
    },
    wasPending: () => {
      return false;
    },
    pending: () => {
      return false;
    },
    shouldShow: props => {
      return may('ROLE_ADMIN', props.user.roles) && !may('ROLE_SOLE_REPRESENTATIVE', props.user.roles);
    },
    doShow: () => {
      return <DashboardInitSoleRepresentative />;
    },
  },
  {
    id: 'InitPlugins',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles) && may('ROLE_SOLE_REPRESENTATIVE', user.roles);
    },
    dataElements: props => {
      return (
        <List noRender listName="myWhiteLabelProject" url="/api/whitelabels/my.json" list={props.myWhiteLabelProject} />
      );
    },
    wasPending: prevProps => {
      return prevProps.myWhiteLabelProject.pending;
    },
    pending: props => {
      return props.myWhiteLabelProject.pending;
    },
    shouldShow: props => {
      // check if there are any plugins active
      if (props.myWhiteLabelProject.data.count) {
        const whiteLabelProjects = props.myWhiteLabelProject.data.list;
        let alreadyHasPlugins = false;

        for (let i = 0; i < whiteLabelProjects.length; i++) {
          const plugins = whiteLabelProjects[i].plugins ? whiteLabelProjects[i].plugins : [];
          for (let j = 0; j < plugins.length; j++) {
            if (plugins[j].is_active) {
              alreadyHasPlugins = true;
              break;
            }
          }

          if (alreadyHasPlugins) {
            break;
          }
        }

        return !alreadyHasPlugins;
      }

      return false;
    },
    doShow: props => {
      return <DashboardInitPlugins myWhiteLabelProject={props.myWhiteLabelProject} />;
    },
  },
  {
    id: 'InitLocations',
    checkUserRights: user => {
      return may('ROLE_CRM_LOCATION', user.roles);
    },
    dataElements: props => {
      return <List noRender listName="companyLocations" url="/api/locations.json" list={props.locations} />;
    },
    wasPending: prevProps => {
      return prevProps.locations.pending;
    },
    pending: props => {
      return props.locations.pending;
    },
    shouldShow: props => {
      return props.locations.data.count === 0;
    },
    doShow: props => {
      return <DashboardInitLocations />;
    },
  },
  {
    id: 'InitUsers',
    checkUserRights: user => {
      return may('ROLE_HR_MASTER', user.roles);
    },
    dataElements: props => {
      return (
        <Count
          countName="users"
          url="/api/clients/count.json"
          urlData={{ filters: { type: 'employee' } }}
          count={props.usersCount}
        />
      );
    },
    wasPending: prevProps => {
      return prevProps.usersCount.pending;
    },
    pending: props => {
      return props.usersCount.pending;
    },
    shouldShow: props => {
      return props.usersCount.data === 0;
    },
    doShow: () => {
      return <DashboardInitUsers />;
    },
  },
  {
    id: 'InitCars',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles);
    },
    dataElements: props => {
      return (
        <Count
          countName="items"
          url="/api/items/count.json"
          urlData={{ filters: { type: 'car' } }}
          count={props.carsCount}
        />
      );
    },
    wasPending: prevProps => {
      return prevProps.carsCount.pending;
    },
    pending: props => {
      return props.carsCount.pending;
    },
    shouldShow: props => {
      return props.carsCount.data === 0;
    },
    doShow: () => {
      return <DashboardInitCars />;
    },
  },
  {
    id: 'FinishPluginConfig',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles);
    },
    dataElements: props => {
      return (
        <List
          noRender
          listName="externalAccountsStats"
          url="/api/externalaccountsstats.json"
          list={props.externalAccountsStats}
        />
      );
    },
    wasPending: prevProps => {
      return prevProps.externalAccountsStats.pending;
    },
    pending: props => {
      return props.externalAccountsStats.pending;
    },
    shouldShow: props => {
      return false;

      /* const whiteLabelProjects = props.myWhiteLabelProject.data.list;
      const activePlugins = [];

      for (let i = 0; i < whiteLabelProjects.length; i++) {
        const plugins = whiteLabelProjects[i].plugins ? whiteLabelProjects[i].plugins : [];

        for (let j = 0; j < plugins.length; j++) {
          if (plugins[j].is_active) {
            activePlugins.push(plugins[j].id);
          }
        }
      }

      const mobiledeAccountStats = _find(props.externalAccountsStats.data.list, ['_id', 'mobiledeSellerApi']);
      const vamosoAccountStats = _find(props.externalAccountsStats.data.list, ['_id', 'vamoso']);

      if (
        activePlugins.indexOf(AUTOMOTIVE_SALES_PLUGIN) > -1 &&
        (!mobiledeAccountStats || mobiledeAccountStats.count === 0)
      ) {
        return true;
      }

      if (
        activePlugins.indexOf(AUTOMOTIVE_RENT_PLUGIN) > -1 &&
        activePlugins.indexOf('RENT_SYNC_VAMOSO') &&
        (!mobiledeAccountStats ||
          !vamosoAccountStats ||
          mobiledeAccountStats.count === 0 ||
          vamosoAccountStats.count === 0)
      ) {
        return true;
      }

      return false; */
    },
    doShow: props => {
      return <DashboardFinishPluginConfig />;
    },
  },
  {
    id: 'StripeOnboarding',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles);
    },
    dataElements: props => {
      return <Data dataName="stripe" url="/api/stripe/data.json" data={props.stripeData} />;
    },
    wasPending: prevProps => {
      return prevProps.stripeData.pending;
    },
    pending: props => {
      return props.stripeData.pending;
    },
    shouldShow: props => {
      const { projectConfig, stripeData } = props;
      const { isActive: isStripeActive } = getStripeConfig(projectConfig.data);

      return (
        isStripeActive &&
        isPluginActive(PAYMENT_PLUGIN_STRIPE_CONNECT, projectConfig.data) &&
        !stripeData.data.account_id
      );
    },
    doShow: () => {
      return <DashboardStripeOnboarding />;
    },
  },
  {
    id: 'InitSepaAgreement',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles);
    },
    dataElements: props => {
      return <List noRender listName="sepaAgreements" url="/api/sepaagreements.json" list={props.sepaAgreements} />;
    },
    wasPending: prevProps => {
      return prevProps.sepaAgreements.pending;
    },
    pending: props => {
      return props.sepaAgreements.pending;
    },
    shouldShow: props => {
      return props.sepaAgreements.data.count === 0;
    },
    doShow: props => {
      return <DashboardInitSepaAgreement sepaAgreements={props.sepaAgreements} />;
    },
  } /*
  {
    id: 'InitJahreswagen',
    checkUserRights: user => {
      return may('ROLE_ADMIN', user.roles);
    },
    dataElements: props => {
      return (
        <Data
          dataName="community"
          url="/api/whitelabels/5a62f59a7c567e51ed92503b.json"
          data={props.jahreswagenCommunity}
        />
      );
    },
    wasPending: prevProps => {
      return prevProps.jahreswagenCommunity.pending;
    },
    pending: props => {
      return props.jahreswagenCommunity.pending;
    },
    shouldShow: props => {
      return !props.jahreswagenCommunity.data.is_member;
    },
    doShow: props => {
      return <DashboardInitJahreswagen />;
    },
  } */,
];

// keep track on hints that may need to be diplayed
class DashboardIndex extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeCheck: 0,
      showAll: false,
    };

    for (let i = 0; i < dashList.length; i++) {
      if (dashList[i].checkUserRights(props.user)) {
        this.state.activeCheck = i;
        break;
      }
    }
  }

  componentDidUpdate = prevProps => {
    const { user } = this.props;
    const { activeCheck } = this.state;

    if (activeCheck !== null) {
      const dash = dashList[activeCheck];
      if (dash.wasPending(prevProps) && !dash.pending(this.props)) {
        if (!dash.shouldShow(this.props)) {
          let foundNewDash = false;
          for (let i = activeCheck + 1; i < dashList.length; i++) {
            if (dashList[i].checkUserRights(user)) {
              this.setState({ activeCheck: i });
              foundNewDash = true;
              break;
            }
          }

          if (!foundNewDash) {
            this.setState({ activeCheck: null });
          }
        }
      }
    }
  };

  render() {
    const { activeCheck, showAll } = this.state;

    // return <DashboardInitCars />;

    if (!showAll && activeCheck !== null && dashList[activeCheck]) {
      const dash = dashList[activeCheck];
      const pending = dash.pending(this.props);
      const shouldShow = !pending && dash.shouldShow(this.props);

      return (
        <React.Fragment>
          {dash.dataElements(this.props)} {shouldShow && dash.doShow(this.props)}
        </React.Fragment>
      );
    }

    if (showAll) {
      return dashList.map(dash => {
        const pending = dash.pending(this.props);
        return (
          <div className="m-t-15" key={dash.id}>
            {dash.dataElements(this.props)} {!pending && dash.doShow(this.props)}
          </div>
        );
      });
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    projectConfig: state.data.projectConfig,
    locations: state.list.companyLocations,
    usersCount: state.count.users,
    carsCount: state.count.items,
    stripeData: state.data.stripe,
    sepaAgreements: state.list.sepaAgreements,
    myWhiteLabelProject: state.list.myWhiteLabelProject,
    externalAccountsStats: state.list.externalAccountsStats,
    jahreswagenCommunity: state.data.community,
  };
};

export default connect(mapStateToProps)(DashboardIndex);
